/**
 * accountGroup模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const accountGroup = {
  //添加账户
  createAccount(params) {
    return $http.post(`${global.API_URL}/sme/accountGroup/createAccountGroup`,params);
  },
  //查询账户组
  selectAccountGroup(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/accountGroup/select`,param);
  },
  // 财务账户组管理分页
  pageAccountGroup(params) {
    return $http.post(`${global.API_URL}/sme/accountGroup/page`,params);
  },
  //添加财务账户组
  createAccountGroup(params) {
    return $http.post(`${global.API_URL}/sme/accountGroup/create`,params);
  },
  //编辑财务账户组
  updateAccountGroup(params) {
    return $http.post(`${global.API_URL}/sme/accountGroup/update`,params);
  },
  //删除财务账户组
  deleteAccountGroup(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/accountGroup/delete`,param);
  },
   //账户组列表
  listAccountGroup(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/accountGroup/listAccountGroup`,param);
  },
  //根据地区类型选择区域
  getRegionByAreaType(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/accountGroup/getRegionByAreaType`,param);
  },
  //获取账户组下拉框
  getAccountGroupList(userName, cloudType) {
    return $http.post(`${global.API_URL}/sme/accountGroup/getAccountGroupList?userName=${userName}&cloudType=${cloudType}`);
  },
  //财务账户组名称重复检查
  checkAccountGroupName(params) {
    return $http.post(`${global.API_URL}/sme/accountGroup/checkAccountGroupName`,params);
  }
}

export default accountGroup;



// WEBPACK FOOTER //
// ./src/api/accountGroup.js